module.exports = __webpack_public_path__ + "static/media/Coinbase.ca836ac1.png";